exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vue-scrollbar-horizontal[data-v-b13fd080]{position:absolute;width:100%;left:0;background:transparent;z-index:9999}.vue-scrollbar-horizontal .scrollbar-inner[data-v-b13fd080]{position:relative;cursor:default;opacity:.8}", ""]);

// exports
